import { FeedPage } from '@/pages/feed/FeedPage'

/**
 * /app/record/pick, a deep link to Record ＋ (Brian's after/rec-pick.js).
 * Record ＋ is a sheet over whatever screen is open (the Shell holds it and
 * opens it on this path); here it sits over the feed, and closing it leaves
 * the feed.
 */
export function RecordPickPage() {
  return <FeedPage />
}
